export default __webpack_public_path__ + "images/SQ.477d0be.png";